import React from 'react';

export const PointSeriesPage = () => (
    <div className="space-y-6">
        {/* Header Section */}
        <div className="text-center space-y-2">
            <h2 className="heading-primary-1 text-4xl font-extrabold">
                Chico Area Dart Association Presents:
                <br />
                <span className="subheading-primary-1">The 4th Annual Hot Summer Nights Point Series 🎯</span>
            </h2>
            <p className="text-lg font-semibold text-muted">EVERY TUESDAY JUNE 2nd – AUGUST 18th</p>
            <p className="tag tag-solid tag-warning">NIGHTLY SIGN-UPS 6:45-7:00 PM. SERIES TOURNAMENTS WILL START AT 7:05PM</p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            {/* Box 1: Series Tournament Rules */}
            <div className="card rounded-lg shadow-sm border border-low p-6 border-t-4 border-primary-one">
                <h3 className="text-xl font-semibold heading-primary-1 mb-2">Series Rules</h3>
                <ul className="list-decimal list-inside space-y-2 text text-base">
                    <li>
                        <span className="font-semibold">Tournament style</span> determined by entries each Tuesday (Random Draw, Singles/Doubles, Bracket/Round Robin, “Chicago” 301+501+Cricket).
                    </li>
                    <li>
                        A <span className="font-semibold">minimum of 2 players</span> are required to play and earn points.
                    </li>
                    <li>
                        <span className="font-semibold">Darts must be played</span> to earn points.
                    </li>
                    <li>
                        <span className="font-semibold">Rolling Mystery Out</span> can be won each Tuesday but will aggregate if no player has hit the randomly chosen out. A new out is randomly chosen each week.
                    </li>
                    <li>
                        Prizes will be awarded to the <span className="font-semibold">TOP 10 LEADERBOARD FINALISTS</span>.
                    </li>
                </ul>
            </div>

            {/* Box 2: Final Tournament Rules */}
            <div className="card rounded-lg shadow-sm border border-low p-6 border-t-4 border-secondary-one">
                <h3 className="text-xl font-semibold heading-secondary-1 mb-2">Hot Shot Final: 8/25</h3>
                <ul className="list-decimal list-inside space-y-2 text text-base">
                    <li>
                        The Final “Hot Shot” Tournament will be <span className="font-semibold">SINGLES</span>.
                    </li>
                    <li>
                        <span className="font-semibold">No entry fee</span>. To qualify you must have played in a <span className="font-semibold">MINIMUM of 6 series tournaments</span> OR have accumulated a <span className="font-semibold">MINIMUM of 29 points</span>.
                    </li>
                    <li>
                        <span className="font-semibold">All players will be paid out!</span> Rolling Mystery Out will be paid out!
                    </li>
                    <li>
                        The Final will be held on <span className="font-semibold">AUGUST 25TH at 6:30pm</span> (Singles, Chicago, Best Of, Seeded Double Elimination Bracket).
                    </li>
                </ul>
            </div>

            {/* Box 3: Entry Fee */}
            <div className="card rounded-lg shadow-sm border border-low p-6 border-t-4 border-success">
                <h3 className="text-xl font-semibold text-success mb-1">Entry Fee Breakdown</h3>
                <p className="text-sm text-muted mb-3">Per Player/Night — Breakdown</p>
                <ul className="space-y-2 text">
                    <li className="flex items-center justify-between">
                        <span className="font-medium">Total</span>
                        <span className="tag tag-success font-semibold">$10</span>
                    </li>
                    <li className="flex items-center justify-between">
                        <span>Nightly Winner Payout</span>
                        <span className="tag tag-primary-one font-semibold">$5</span>
                    </li>
                    <li className="flex items-center justify-between">
                        <span>Finalist Payouts</span>
                        <span className="tag tag-secondary-one font-semibold">$3</span>
                    </li>
                    <li className="flex items-center justify-between">
                        <span>Rolling Mystery Out</span>
                        <span className="tag tag-warning font-semibold">$2</span>
                    </li>
                </ul>
            </div>

            {/* Box 4: How to Score Points */}
            <div className="card rounded-lg shadow-sm border border-low p-6 border-t-4 border-warning">
                <h3 className="text-xl font-semibold text-warning mb-2">How to Score Points</h3>
                <ul className="space-y-2 text">
                    <li className="flex items-center justify-between">
                        <span>Sign up</span>
                        <span className="tag tag-warning font-semibold">+2</span>
                    </li>
                    <li className="flex items-center justify-between">
                        <span>1st place</span>
                        <span className="tag tag-primary-one font-semibold">+5</span>
                    </li>
                    <li className="flex items-center justify-between">
                        <span>2nd place</span>
                        <span className="tag tag-secondary-one font-semibold">+4</span>
                    </li>
                    <li className="flex items-center justify-between">
                        <span>3rd place</span>
                        <span className="tag tag-success font-semibold">+3</span>
                    </li>
                    <li className="flex items-center justify-between">
                        <span>4th place</span>
                        <span className="tag tag-info font-semibold">+2</span>
                    </li>
                    <li className="flex items-center justify-between">
                        <span>5th/6th/7th…</span>
                        <span className="tag tag-neutral font-semibold">+1</span>
                    </li>
                </ul>
            </div>
        </div>

        {/* Schedule Section */}
        <div className="card rounded-lg shadow-sm border border-low p-6">
            <h3 className="text-xl font-semibold heading-primary-1 mb-3 text-center">Schedule</h3>
            <p className="text-sm text-muted text-center mb-4">Check chicodarts.org for updated locations!</p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
                <div>
                    <p className="font-bold">June</p>
                    <ul className="text-sm text-muted">
                        <li>6/2 - Down Lo</li>
                        <li>6/9 - Down Lo</li>
                        <li>6/16 - Down Lo</li>
                        <li>6/23 - Down Lo</li>
                        <li>6/30 - Down Lo</li>
                    </ul>
                </div>
                <div>
                    <p className="font-bold">July</p>
                    <ul className="text-sm text-muted">
                        <li>7/7 - Down Lo</li>
                        <li>7/14 - Down Lo</li>
                        <li>7/21 - Down Lo</li>
                        <li>7/28 - Down Lo</li>
                    </ul>
                </div>
                <div>
                    <p className="font-bold">August</p>
                    <ul className="text-sm text-muted">
                        <li>8/4 - Down Lo</li>
                        <li>8/11 - Down Lo</li>
                        <li>8/18 - Down Lo</li>
                    </ul>
                </div>
                <div>
                    <p className="font-bold text-danger">Final</p>
                    <ul className="text-sm text-muted">
                        <li>8/25 - Down Lo - HOT SHOT (6:30pm)</li>
                    </ul>
                </div>
            </div>
        </div>

        {/* Contact Section */}
        <div className="text-center">
            <p>Contact Chico Darts for Questions: <a href="mailto:chicodarts530@gmail.com" className="text-info font-semibold hover:underline">chicodarts530@gmail.com</a></p>
        </div>
    </div>
);